import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core'
import AddPhonesLarge from './AddPhonesLarge'
import AddPhonesSmall from './AddPhonesSmall'

const mapStateToProps = state => ({
    smallView: state.smallView
})

const mapDispatchToProps = dispatch => ({
})

const styles = theme => ({
    addPhonesContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%'
    },
})

class AddPhones extends Component {
    constructor (props) {
        super(props)
        this.state = {
            loading: false
        }
    }

    componentDidMount () {
        console.log('init add-phones')
    }

    renderMain = () => {
        if (this.state.loading) return
        const MyPhonesSubcomponent = this.props.smallView ? AddPhonesSmall : AddPhonesLarge
        return (
            <MyPhonesSubcomponent
            />

        )
    }
    render () {
        const { classes } = this.props
        return (
            <div className={classes.addPhonesContainer}>
                {this.renderMain()}
            </div>

        )
    }
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(AddPhones))
